import React from 'react';
import { cn } from '@/lib/utils';

interface CardTotalProps {
  title?: string;
  total?: number | string;
  styleTitle?: string;
  unit?: string;
  className?: string;
}

const CardTotal = ({ title, styleTitle, total, unit, className }: CardTotalProps) => {
  return (
    <div className={cn('shadowCard w-full flex flex-col gap-3 md:p-6 p-3', className)}>
      <p
        className={cn(
          'px-3 py-1 text-center rounded-[4px] bg-text-blue-12 w-fit  capitalize text-[clamp(12px,2vw,16px)] font-normal',
          styleTitle
        )}
      >
        {title}
      </p>

      <div className="inline-flex items-center gap-3 flex-wrap">
        <span className="h3boldto28 break-all ">{total}</span>
        {unit && <span className="capitalize title1regto12 truncate ">{unit}</span>}
      </div>
    </div>
  );
};

export default CardTotal;
